import React, { useState } from "react";
import "./BarScreen.css";

const DRINKS = [
  {
    name: "Mango John Collins",
    image: "/bar/mango-john-collins.jpg",
    ingredients: [
      "Wódka",
      "Sok z cytryny",
      "Syrop cukrowy",
      "Puree mango",
    ],
  },
  {
    name: "Strawberry Shots",
    image: "/bar/strawberry-shots.jpg",
    ingredients: [
      "Wódka",
      "Sok z cytryny",
      "Puree truskawkowe",
    ],
  },
  {
    name: "Plum Whisky Sour",
    image: "/bar/plum-whisky-sour.jpg",
    ingredients: [
      "Whisky",
      "Sok z cytryny",
      "Syrop cukrowy",
      "Białko",
      "Angostura bitters",
      "Powidła śliwkowe",
    ],
  },
  {
    name: "Strawberry Mojito",
    image: "/bar/strawberry-mojito.jpg",
    ingredients: [
      "Rum",
      "Mięta",
      "Sok z limonki",
      "Puree truskawkowe",
      "Syrop cukrowy",
      "Woda gazowana",
    ],
  },
  {
    name: "Whisky Passion Fruit",
    image: "/bar/whisky-passion-fruit.jpg",
    ingredients: [
      "Whisky",
      "Sok z cytryny",
      "Syrop cukrowy",
      "Białko",
      "Angostura bitters",
      "Puree marakuja",
    ],
  },
  {
    name: "Hot Strawberry Margarita",
    image: "/bar/hot-strawberry-margarita.jpg",
    ingredients: [
      "Tequila",
      "Cointreau",
      "Sok z limonki",
      "Syrop chilli",
      "Puree truskawkowe",
    ],
  },
  {
    name: "Aperol",
    image: "/bar/aperol.jpg",
    ingredients: [
      "Aperol",
      "Prosecco",
      "Woda gazowana",
    ],
  },
];

export default function BarScreen() {
  const [preview, setPreview] = useState(null); // { name, image }

  return (
    <div className="screen">
      <div className="page-header">
        <h1 className="page-header__title">Bar</h1>
        <p className="page-header__sub">Karta napojów</p>
      </div>

      <div className="screen__body">
        <div className="bar__list">
          {DRINKS.map((drink) => (
            <div key={drink.name} className="bar__card">
              <div className="bar__card-top">
                <div className="bar__name">{drink.name}</div>
                {drink.image && (
                  <button
                    className="bar__preview-btn"
                    onClick={() => setPreview(drink)}
                    title="Zobacz zdjęcie"
                  >
                    <EyeIcon />
                  </button>
                )}
              </div>
              {drink.ingredients.length > 0 && (
                <ul className="bar__ingredients">
                  {drink.ingredients.map((ing) => (
                    <li key={ing}>{ing}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <div className="bar__classic-note">
          <span className="bar__classic-icon">🍸</span>
          <p>Dostępne są również wszystkie klasyczne drinki — zapytaj barmana!</p>
        </div>
      </div>

      {preview && (
        <div className="bar__overlay" onClick={() => setPreview(null)}>
          <div className="bar__lightbox" onClick={(e) => e.stopPropagation()}>
            <img
              src={preview.image}
              alt={preview.name}
              className="bar__lightbox-img"
            />
            <div className="bar__lightbox-name">{preview.name}</div>
            <button
              className="bar__lightbox-close"
              onClick={() => setPreview(null)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

function EyeIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
      strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}
